import { Box } from 'components/ui';
import type { AuthTitleTextProps } from './AuthTitleText.props';

const AuthTitleText = ({ lead, tail }: AuthTitleTextProps) => (
  <>
    {lead}
    {tail ? (
      <>
        {' '}
        <Box component="span" sx={{ fontWeight: 400 }}>
          {tail}
        </Box>
      </>
    ) : null}
  </>
);

export default AuthTitleText;
